import React from 'react';
import { useIdentificationContext, Variant } from '@fiverr-private/identification_core';
import { useStepsContext } from '../StepsContext';
import { StepWrapper } from '../../shared/components/StepWrapper';
import { InitialStep } from '../InitialStep';
import { ChangeEmailStep } from '../ChangeEmailStep';
import { EmailIdentificationStep } from '../EmailIdentificationStep';
import { ResetPasswordStep } from '../ResetPasswordStep';
import { CodeActivationStep } from '../CodeActivationStep';
import { ProfileSetupStep } from '../ProfileSetupStep';
import { SocialFallbackStep } from '../SocialFallbackStep';
import { OnboardingStepWrapper } from '../OnboardingStepWrapper';

const getWrapperComponent = (variant: Variant) => {
    switch (variant) {
        case 'onboarding':
            return OnboardingStepWrapper;
        default:
            return StepWrapper;
    }
};

export const ActiveStep = () => {
    const { activeStepId } = useStepsContext();
    const { variant } = useIdentificationContext();
    const Wrapper = getWrapperComponent(variant);

    switch (activeStepId) {
        case 'initial':
            return (
                <Wrapper showDisclaimer stepCentered>
                    <InitialStep />
                </Wrapper>
            );
        case 'email_identification':
            return (
                <Wrapper showDisclaimer>
                    <EmailIdentificationStep />
                </Wrapper>
            );
        case 'reset_password':
            return (
                <Wrapper>
                    <ResetPasswordStep />
                </Wrapper>
            );
        case 'code_activation':
            return (
                <Wrapper>
                    <CodeActivationStep />
                </Wrapper>
            );
        case 'change_email':
            return (
                <Wrapper>
                    <ChangeEmailStep />
                </Wrapper>
            );
        case 'profile_setup':
            return (
                <Wrapper>
                    <ProfileSetupStep />
                </Wrapper>
            );
        case 'social_fallback':
            return (
                <Wrapper showDisclaimer>
                    <SocialFallbackStep />
                </Wrapper>
            );
        default:
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const _exhaustiveCheck: never = activeStepId;
            return null;
    }
};
